import CarouselBlock from './CarouselBlock';

export default CarouselBlock;
